//引入
import { JSEncrypt } from 'jsencrypt'
import { getRsaPubKey } from "@/api/index";
import { getCookie, setCookie } from '@/utils/cookie';
import httpStatusCode from  "@/utils/httpStatusCode"

/**
 * 加密
 * @param {String}  需要加密的参数
 */
// export async function passwordEncryption (param) {
// 	let passwordEncryp;
// 	if (getCookie("rsaKey")) {
// 		var PUBLIC_KEY = getCookie("rsaKey")
// 		let encryptor = new JSEncrypt() // 新建JSEncrypt对象
// 		encryptor.setPublicKey(PUBLIC_KEY) // 设置公钥
// 		passwordEncryp = encryptor.encrypt(param) // 对密码进行加密
// 	} else {
// 		await getData().then((result) => {
// 			let encryptor = new JSEncrypt() // 新建JSEncrypt对象
// 			encryptor.setPublicKey(result) // 设置公钥
// 			passwordEncryp = encryptor.encrypt(param) // 对密码进行加密
// 		})
// 	}
// 	return passwordEncryp
//
// }
//
// // 解密 -- 暂无使用
// export function decrypt (msg) {
// 	let decrypt = new JSEncrypt()
// 	decrypt.setPrivateKey(PRIVATE_KEY)
// 	var decryptMsg = decrypt.decrypt(msg)
// 	return decryptMsg
// }
// // 获取公钥
// function getData() {
// 	return new Promise(function(resolve, reject) {
// 		getRsaPubKey().then(res=> {
// 			if(res.code == httpStatusCode.StatusOK) {
// 				setCookie('rsaKey', res.data)
// 				resolve(res.data);
// 			} else {
// 				reject(res.error);
// 			}
// 		})
// 	});
// }



/**
 * 加密
 * @param {String}  需要加密的参数
 */
export async function passwordEncryption (param) {
  console.error(param)
  let passwordEncryp;
  if (localStorage.getItem("rsaKey") != null) {
    var PUBLIC_KEY = localStorage.getItem("rsaKey")
    console.error('PUBLIC_KEY',PUBLIC_KEY)
    let encryptor = new JSEncrypt() // 新建JSEncrypt对象
    encryptor.setPublicKey(PUBLIC_KEY) // 设置公钥
    passwordEncryp = encryptor.encrypt(param) // 对密码进行加密
  } else {
    await getData().then((result) => {
      let encryptor = new JSEncrypt() // 新建JSEncrypt对象
      encryptor.setPublicKey(result) // 设置公钥
      passwordEncryp = encryptor.encrypt(param) // 对密码进行加密
    })
  }
  console.error('passwordEncryp',passwordEncryp)
  return passwordEncryp
}

// 解密 -- 暂无使用
export function decrypt (msg) {
  let decrypt = new JSEncrypt()
  decrypt.setPrivateKey(PRIVATE_KEY)
  var decryptMsg = decrypt.decrypt(msg)
  return decryptMsg
}

// 获取公钥
function getData() {
  return new Promise(function(resolve, reject) {
    getRsaPubKey().then(res=> {
      if(res.code == 200) {
        localStorage.setItem('rsaKey', res.data)
        resolve(res.data);
      } else {
        reject(res.error);
      }
    })
  });
}
